/**
 * Sort fields accepted by GET /admin/video-uploads (OpenAPI on GetVideosController).
 * The generated client enum is stale and omits apiStatus, origin, metadata.gameId, etc.
 */
export const videoUploadSortFields = [
	"name",
	"duration",
	"size",
	"createdAt",
	"worker",
	"gameId",
	"metadata.gameId",
	"processingStartedAt",
	"processingFinishedAt",
	"width",
	"bitRate",
	"approvedBy",
	"metadataAddedBy",
	"status",
	"lastEvent",
	"uploadedBy",
	"origin",
	"apiStatus",
	"deletedAt",
	"deletedBy",
	"providerMetadata.clubhouse_name",
	"providerMetadata.recording_slug",
	"veo_team",
] as const;

export type VideoUploadSortField = (typeof videoUploadSortFields)[number];

export enum VideoUploadSortDirection {
	Asc = "asc",
	Desc = "desc",
}

const videoUploadSortFieldSet = new Set<string>(videoUploadSortFields);

export function isVideoUploadSortDirection(value: string | undefined): value is VideoUploadSortDirection {
	return value === VideoUploadSortDirection.Asc || value === VideoUploadSortDirection.Desc;
}

export function isVideoUploadSortField(value: string | undefined): value is VideoUploadSortField {
	if (value === undefined || value === "") {
		return false;
	}

	return videoUploadSortFieldSet.has(value);
}

export type VideoUploadSortConfig = {
	name: string | undefined;
	sort: VideoUploadSortDirection | undefined;
};

/** Cycles unsorted → asc ↔ desc. The third click stays sorted instead of dropping `order`. */
export function nextVideoUploadSortConfig(
	columnName: string,
	sortConfig: VideoUploadSortConfig,
): VideoUploadSortConfig {
	if (sortConfig.name === columnName && sortConfig.sort === VideoUploadSortDirection.Asc) {
		return { name: columnName, sort: VideoUploadSortDirection.Desc };
	}

	return { name: columnName, sort: VideoUploadSortDirection.Asc };
}
